"use client";

import { motion } from "framer-motion";
import { ScanFace } from "lucide-react";
import { Card } from "@/components/ui/card";
const ecosystemItems = [{
  num: "01",
  title: "Articolo del blog",
  description: "Dedicato alla tua storia, esperienza o azienda"
}, {
  num: "02",
  title: "Presenza sul sito",
  description: "lioniaproject.com"
}, {
  num: "03",
  title: "Pubblicazione social",
  description: "YouTube, Instagram e LinkedIn"
}, {
  num: "04",
  title: "Case study",
  description: "Eventuale presenza nel Brand Wall"
}, {
  num: "05",
  title: "Community",
  description: "Visibilità tra CEO, marketers e creativi"
}, {
  num: "06",
  title: "Gadget Lionia",
  description: "La maglietta con la leonessa"
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function ContentEcosystemGrid() {
  return <section id="contentecosystemgrid" className="bg-background py-24 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        
        {}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="mb-4 block text-xs font-bold tracking-widest text-primary uppercase">
              Cosa ricevi
            </span>
            <h2 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl">
              Il contenuto <br className="hidden sm:block" />
              <span className="text-primary">continua.</span>
            </h2>
          </div>
          <p className="max-w-sm text-muted-foreground md:text-right text-sm sm:text-base">
            Ogni storia entra nell'ecosistema Lionia e trova più canali per essere raccontata.
          </p>
        </motion.div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2">
          {ecosystemItems.map((item, i) => <motion.div key={i} variants={itemVariants} data-index={i}>
              <Card className="group flex h-full flex-row items-start gap-4 sm:gap-6 border-border bg-card p-6 transition-colors duration-300 hover:border-primary shadow-sm hover:shadow-md">
                <div className="flex size-10 sm:size-12 shrink-0 items-center justify-center rounded-lg bg-muted text-sm font-bold text-primary transition-colors group-hover:bg-primary/10">
                  {item.num}
                </div>
                <div className="flex flex-col gap-1 sm:gap-2">
                  <h3 className="font-default text-lg sm:text-xl font-bold text-foreground">
                    {item.title}
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    {item.description}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </motion.div>

        {}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-20 flex justify-center">
          <div className="inline-flex items-center gap-3 rounded-lg border border-border bg-card px-6 py-3 shadow-sm">
            <ScanFace className="size-5 text-primary" />
            <span className="text-xs font-bold tracking-widest text-muted-foreground uppercase">
              Cosa ottieni
            </span>
          </div>
        </motion.div>

      </div>
    </section>;
}